export const TRANSLATION_KEYS = {
    Heading: "settingPage.topicPage.deleteDialog.heading",
    SecondaryHeading: "settingPage.topicPage.deleteDialog.secondaryHeading",
    ConfirmText: "common.deleteText",
    DismissText: "common.dismissText"
};